import { tagAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tagAnatomy.keys)

const variants = {
  subtle: definePartsStyle({
    container: {
      bg: 'bg-muted',
      color: 'default',
      borderRadius: 'full',
    },
  }),
}

export default defineMultiStyleConfig({ variants })
